class FenzaCartGiftToggle extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.fenza-cart-gifting__heading input[type="checkbox"]');
    this.heading = this.querySelector('.fenza-cart-gifting__heading');
    this.options = this.querySelector('.fenza-cart-gifting__options');
    this.invoice = this.querySelector('[data-hide-invoice]');
    this.heading?.addEventListener('click', this.handleHeadingClick);
    this.input?.addEventListener('change', this.handleChange);
    this.invoice?.addEventListener('change', this.savePreferences);
  }

  disconnectedCallback() {
    this.heading?.removeEventListener('click', this.handleHeadingClick);
    this.input?.removeEventListener('change', this.handleChange);
    this.invoice?.removeEventListener('change', this.savePreferences);
  }

  savePreferences = async () => {
    try {
      await fetch(this.dataset.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Faturada fiyatı gizle': this.invoice?.checked ? 'Evet' : 'Hayır',
          },
        }),
      });
    } catch (error) {
      console.warn('[fenza-cart-gift-preferences]', error);
    }
  };

  handleHeadingClick = (event) => {
    if (!this.input || this.input.disabled || this.hasAttribute('data-loading')) return;

    // Etiketin tarayıcıya bağlı doğal davranışına güvenmeden bütün başlık satırını
    // tek ve tutarlı bir tıklama alanı olarak çalıştırır.
    event.preventDefault();
    this.input.checked = !this.input.checked;
    this.handleChange();
  };

  handleChange = async () => {
    if (!this.input || this.input.disabled) return;
    const checked = this.input.checked;
    this.toggleAttribute('data-loading', true);
    this.setAttribute('aria-busy', 'true');
    this.input.disabled = true;

    try {
      const response = checked
        ? await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(this.input.dataset.variantId),
                quantity: 1,
                properties: {
                  _fenza_gift_wrap: 'true',
                },
              }],
            }),
          })
        : await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.input.dataset.lineKey, quantity: 0 }),
          });

      if (!response.ok) throw new Error('Gift wrap update failed');
      const result = await response.json();

      if (checked) {
        this.input.dataset.lineKey = result.items?.[0]?.key || '';
        if (this.options) this.options.hidden = false;
        await this.savePreferences();
      } else {
        this.input.dataset.lineKey = '';
        if (this.options) this.options.hidden = true;
      }

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        const formattedTotal = `${new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cart.total_price / 100)} TL`;
        document.querySelectorAll('.fenza-cart-costs > div:first-child strong, .fenza-cart-costs__total strong')
          .forEach((node) => { node.textContent = formattedTotal; });
      }

      this.input.disabled = false;
      this.removeAttribute('data-loading');
      this.removeAttribute('aria-busy');
    } catch (error) {
      this.input.checked = !checked;
      this.input.disabled = false;
      this.removeAttribute('data-loading');
      this.removeAttribute('aria-busy');
      console.warn('[fenza-cart-gift]', error);
    }
  };
}

if (!customElements.get('cart-gift-toggle')) {
  customElements.define('cart-gift-toggle', FenzaCartGiftToggle);
}
